<div class=" o-modal--alert o-modal--error o-modal--medium" id="mod-mod-req">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal" matDialogClose></a>
        <label class="o-title o-title--white o-title--medium">{{ 'ModalDeleteSaadelegatePortal.title' | translate }}</label>
    </div>
    <div class="o-modal__body">
       
    </div>
    <div class="o-modal__footer">
        <div>
            <button mat-button mat-dialog-close (click)="Close()" class class="btn btn--default" >{{ 'ModalDeleteSaadelegatePortal.buttonCancel' | translate }} </button>
            <button mat-button  (click)="Accept()" class class="btn btn--primary" >{{ 'ModalDeleteSaadelegatePortal.buttonDelete' | translate }}</button>
        </div>
    </div>
</div>